import { ReactElement } from "react";
import { IFormHandler } from "client/Forms";
import { localize } from "client_legacy/ndaw/culture";
import { ActivityFeedSettingsState } from "./NotificationSettingsDialog";
import { NotificationSection } from "./NotificationSection";

export type BirthdayActivitySectionProps = {
	formHandler: IFormHandler<ActivityFeedSettingsState>;
};

export const BirthdayActivitySection = (props: BirthdayActivitySectionProps): ReactElement => {
	const { formHandler } = props;

	return (
		<NotificationSection
			title={localize("_Birthdays")}
			trackingId="birthdays"
		>
			<NotificationSection.ItemList>
				<NotificationSection.Item
					label={localize("_Birthdays")}
					subtext={localize("_BirthdaysActivityDescription")}
					attachable={formHandler.for("birthdays")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>

				<NotificationSection.Item
					label={localize("_BirthdayWishes")}
					subtext={localize("_BirthdayWishesActivityDescription")}
					attachable={formHandler.for("birthdayWishes")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>

				<NotificationSection.Item
					label={localize("_BirthdayWishReactions")}
					subtext={localize("_BirthdayWishReactionsActivityDescription")}
					attachable={formHandler.for("birthdayWishReactions")
						.for("isEnabled")
						.attachToCheckbox()
					}
				/>
			</NotificationSection.ItemList>
		</NotificationSection>
	);
};

BirthdayActivitySection.displayName = "BirthdayActivitySection";
